// extracted by mini-css-extract-plugin
module.exports = {"container":"error-boundary_container__3hXWE","link":"error-boundary_link__1gIcf"};